import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row animated fadeIn"
}
const _hoisted_2 = { class: "col-xl-12 col-lg-12" }
const _hoisted_3 = { class: "card shadow mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }, [
  /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, " Register Deposits "),
  /*#__PURE__*/_createVNode("small", { class: "ml-2" }, "Please provide the required information.")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6 offset-md-3 text-left" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "form-group text-left" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "currencyId" }, " Currency:* ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", {
  value: undefined,
  selected: "",
  disabled: ""
}, " Select Currency ", -1)
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "form-group text-left" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { for: "accountingHour" }, " Accounting Hour:* ", -1)
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "form-group text-left" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "amount" }, " Amount:* ", -1)
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = { class: "input-group-prepend" }
const _hoisted_24 = { class: "input-group-text" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = {
  key: 0,
  class: "col-12"
}
const _hoisted_27 = { class: "form-group text-left" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "usdExchangeValue" }, " USD Value $: ", -1)
const _hoisted_29 = { class: "input-group" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("div", { class: "input-group-text" }, " USD ")
], -1)
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = {
  key: 1,
  class: "col-12"
}
const _hoisted_33 = { class: "form-group text-left" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "cadExchangeValue" }, " CAD Value $: ", -1)
const _hoisted_35 = { class: "input-group" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("div", { class: "input-group-text" }, " CAD ")
], -1)
const _hoisted_37 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = { class: "form-group text-left" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "transactionAuthCode" }, " Transaction Auth Code (optional): ", -1)
const _hoisted_41 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = { class: "form-group text-left" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { for: "amount" }, " File (optional): ", -1)
const _hoisted_45 = { class: "card-footer" }
const _hoisted_46 = { class: "container" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-6 offset-md-3 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_amountInput = _resolveComponent("amountInput")

  return (_ctx.user)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _withDirectives(_createVNode("select", {
                            id: "currencyId",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.depositForm.props.currencyId = $event)),
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectCurrency && _ctx.selectCurrency(...args)))
                          }, [
                            _hoisted_13,
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCurrencies, (c) => {
                              return (_openBlock(), _createBlock("option", {
                                key: c.id,
                                value: c.id
                              }, _toDisplayString(c.id) + " " + _toDisplayString(c.description), 9, ["value"]))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.depositForm.props.currencyId]
                          ]),
                          (_ctx.depositForm.controls.currencyId.dirty)
                            ? (_openBlock(), _createBlock("small", _hoisted_14, _toDisplayString(_ctx.depositForm.controls.currencyId.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_15, [
                        _createVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _withDirectives(_createVNode("input", {
                            class: "form-control",
                            type: "datetime-local",
                            name: "accountingHour",
                            id: "accountingHour",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.depositForm.props.createdAt = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.depositForm.props.createdAt]
                          ]),
                          (_ctx.depositForm.controls.createdAt.dirty)
                            ? (_openBlock(), _createBlock("small", _hoisted_18, _toDisplayString(_ctx.depositForm.controls.createdAt.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode("div", _hoisted_22, [
                            _createVNode("div", _hoisted_23, [
                              _createVNode("div", _hoisted_24, _toDisplayString(_ctx.currentCurrency?.id), 1)
                            ]),
                            _createVNode(_component_amountInput, {
                              disabled: 
                            !_ctx.depositForm.props.createdAt ||
                              !_ctx.depositForm.props.currencyId
                          ,
                              "onUpdate:amount": _cache[4] || (_cache[4] = ($event: any) => (_ctx.depositForm.props.amount = $event)),
                              amount: parseFloat(_ctx.depositForm.props.amount),
                              precision: _ctx.currentCurrency?.exact,
                              onInput: _ctx.inputAmount
                            }, null, 8, ["disabled", "amount", "precision", "onInput"])
                          ]),
                          (_ctx.depositForm.controls.amount.dirty)
                            ? (_openBlock(), _createBlock("small", _hoisted_25, _toDisplayString(_ctx.depositForm.controls.amount.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.currentCurrency?.currencyType === 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_26, [
                            _createVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createVNode(_component_amountInput, {
                                  id: "usdExchangeValue",
                                  "onUpdate:amount": _cache[5] || (_cache[5] = ($event: any) => (
                            _ctx.depositForm.props.usdExchangeValue = parseFloat(
                              $event
                            )
                          )),
                                  amount: _ctx.depositForm.props.usdExchangeValue,
                                  precision: 2
                                }, null, 8, ["amount"])
                              ]),
                              (_ctx.depositForm.controls.usdExchangeValue.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_31, _toDisplayString(_ctx.depositForm.controls.usdExchangeValue.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.currentCurrency?.currencyType === 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_32, [
                            _createVNode("div", _hoisted_33, [
                              _hoisted_34,
                              _createVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createVNode(_component_amountInput, {
                                  id: "cadExchangeValue",
                                  "onUpdate:amount": _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.depositForm.props.cadExchangeValue = parseFloat(
                              $event
                            )
                          )),
                                  amount: _ctx.depositForm.props.cadExchangeValue,
                                  precision: 2
                                }, null, 8, ["amount"])
                              ]),
                              (_ctx.depositForm.controls.cadExchangeValue.dirty)
                                ? (_openBlock(), _createBlock("small", _hoisted_37, _toDisplayString(_ctx.depositForm.controls.cadExchangeValue.errorMessage), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_38, [
                        _createVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _withDirectives(_createVNode("input", {
                            id: "transactionAuthCode",
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.depositForm.props.transactionAuthCode = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.depositForm.props.transactionAuthCode]
                          ]),
                          (_ctx.depositForm.controls.transactionAuthCode.dirty)
                            ? (_openBlock(), _createBlock("small", _hoisted_41, _toDisplayString(_ctx.depositForm.controls.transactionAuthCode.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_42, [
                        _createVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createVNode("input", {
                            onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onEntryFile && _ctx.onEntryFile(...args))),
                            id: "amount",
                            type: "file",
                            class: "form-control"
                          }, null, 32)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_45, [
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode("div", _hoisted_48, [
                    _createVNode("button", {
                      disabled: !_ctx.depositForm.props.customerId,
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                      class: "btn btn-success"
                    }, " Save ", 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}